import { MutationTree } from 'vuex';
import PnpToolState from './types';
import PnpItem from '../../../models/PnpItem';

export enum PnpMutationsEnum {
  toggleTool = 'toggleTool',
  initializeState = 'initializeState',
  setHidden = 'setHidden',
  setPnpItemArray = 'setPnpItemArray',
}

export const pnpToolMutations: MutationTree<PnpToolState> = {
  // Tool Visibility
  toggleTool(state, toolType: string): void {
    state.toolMap.set(toolType, !state.toolMap.get(toolType));
  },
  initializeState(state, initialValues: Map<string, boolean>): void {
    initialValues.forEach((value, key) => {
      state.toolMap.set(key, value);
    });
  },
  setHidden(state, toolType: string): void {
    state.toolMap.set(toolType, true);
  },

  // Buttons
  setPnpItemArray(state, newPnpItemArray: Array<PnpItem>): void {
    state.pnpItemArray = newPnpItemArray !== undefined ? newPnpItemArray : new Array<PnpItem>();
  },
};
